import { inputsCustomizations } from '@/theme/customizations/inputs';
import { modalCustomizations } from '@/theme/customizations/modals';
import { surfacesCustomization } from '@/theme/customizations/surfaces';
import { createTheme } from '@mui/material/styles';

const getTheme = (mode) => {
  const theme = createTheme({
    palette: {
      mode,
      primary: {
        main: mode === 'dark' ? '#f5f6fa' : '#333333',
      },
      secondary: {
        main: '#8b6e60',
      },
      brand: {
        main: '#c2cd00',
        light: '#CED733',
        dark: '#878F00',
        contrastText: '#fff',
      },
      water: {
        main: '#1E88E5',
      },
      heat: {
        main: '#ff7226',
      },
      power: {
        main: '#FFC107',
      },
    },
    components: {
      ...inputsCustomizations(mode),
      ...modalCustomizations,
      ...surfacesCustomization,
    },
  });
  return theme;
};

export default getTheme;
